import {
    FETCH_FAQS_REQUEST,
    FETCH_FAQS_SUCCESS,
    FETCH_FAQS_FAILURE,
} from "../actions/types";

const initialState = {
    faqs: [],
    loading: false,
    error: null,
};

const faqReducer = (
    state = initialState,
    action
) => {
    switch (
        action.type
    ) {
        case FETCH_FAQS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_FAQS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                faqs:
                    action.payload,
            };

        case FETCH_FAQS_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

        default:
            return state;
    }
};

export default faqReducer;